<template>
  <v-container class="px-md-5">
    <p class="mx-auto text-center primary--text text-text mb-5 px-12">
      {{ user_profile_my_documents_tab_view_model.translate('description') }}
    </p>
    <v-row justify="center">
      <v-radio-group v-model="user_profile_my_documents_tab_view_model.selected_document">
        <v-radio
          v-for="(option, index) in user_profile_my_documents_tab_view_model.documents_options"
          :key="index"
          :value="option.value"
          color="blue"
          class="mb-10 mb-md-4 mx-0"
        >
          <template v-slot:label>
            <p class="text-body primary--text mt-4">
              {{ option.label }}
            </p>
          </template>
        </v-radio>
      </v-radio-group>
    </v-row>
    <v-row justify="center" class="mt-10">
      <v-col cols="10" md="6" lg="6">
        <v-btn
          color="accent"
          class="text-body white--text"
          rounded
          x-large
          @click="user_profile_my_documents_tab_view_model.openModal"
          :disabled="!user_profile_my_documents_tab_view_model.selected_document"
        >
          {{ user_profile_my_documents_tab_view_model.translate('modify_document') }}
        </v-btn>
      </v-col>
    </v-row>
    <update-proof-of-address-modal
      :is-open.sync="user_profile_my_documents_tab_view_model.show_update_proof_of_address_modal"
      v-if="user_profile_my_documents_tab_view_model.show_update_proof_of_address_modal"
      @openSuccessModal="user_profile_my_documents_tab_view_model.openSuccessModal"
    />
    <update-proof-of-address-wealth-success
      :is-open.sync="user_profile_my_documents_tab_view_model.show_wealth_success_modal"
      v-if="user_profile_my_documents_tab_view_model.show_wealth_success_modal"
    />
    <update-proof-of-address-pocket-success
      :is-open.sync="user_profile_my_documents_tab_view_model.show_pocket_success_modal"
      v-if="user_profile_my_documents_tab_view_model.show_pocket_success_modal"
    />
    <update-bank-account-modal
      :is-open.sync="user_profile_my_documents_tab_view_model.show_update_bank_account_modal"
      v-if="user_profile_my_documents_tab_view_model.show_update_bank_account_modal"
      @openUpdatedBankAccountSuccessModal="
        user_profile_my_documents_tab_view_model.openUpdatedBankAccountSuccessModal"
    />
    <update-bank-account-wealth-success
      :is-open.sync="user_profile_my_documents_tab_view_model
        .show_bank_account_wealth_success_modal"
      v-if="user_profile_my_documents_tab_view_model.show_bank_account_wealth_success_modal"
    />
    <update-bank-account-pocket-success
      :is-open.sync="user_profile_my_documents_tab_view_model
        .show_bank_account_pocket_success_modal"
      v-if="user_profile_my_documents_tab_view_model.show_bank_account_pocket_success_modal"
    />
    <update-ine-confirmation-modal
      :is-open.sync="user_profile_my_documents_tab_view_model.show_ine_confirmation_modal"
      v-if="user_profile_my_documents_tab_view_model.show_ine_confirmation_modal"
    />
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import UserProfileMyDocumentsTabViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/user-profile-my-documents-tab-view-model';

@Component({
  name: 'UserProfileMyDocumentsTab',
  components: {
    UpdateProofOfAddressModal: () => import('./update-proof-of-address/UpdateProofOfAddressModal.vue'),
    UpdateProofOfAddressWealthSuccess: () => import('./update-proof-of-address/UpdateProofOfAddressWealthSuccess.vue'),
    UpdateProofOfAddressPocketSuccess: () => import('./update-proof-of-address/UpdateProofOfAddressPocketSuccess.vue'),
    UpdateBankAccountModal: () => import('./update-bank-account/UpdateBankAccountModal.vue'),
    UpdateBankAccountWealthSuccess: () => import('./update-bank-account/UpdateBankAccountWealthSuccess.vue'),
    UpdateBankAccountPocketSuccess: () => import('./update-bank-account/UpdateBankAccountPocketSuccess.vue'),
    UpdateIneConfirmationModal: () => import('./update-ine/UpdateIneConfirmationModal.vue'),
  },
})
export default class UserProfileMyDocumentsTab extends Vue {
  user_profile_my_documents_tab_view_model = Vue.observable(
    new UserProfileMyDocumentsTabViewModel(),
  );
}
</script>
